import { Box, Icon } from "@chakra-ui/react"
import { FramerBox } from "@components/animations/FramerBox"
import { Countries } from "@data/map"
import SvgWorldMap from "@public/svg/map/world-map.svg"
import { AnimatePresence } from "framer-motion"

const FooterWorldMap = () => {
  return (
    <AnimatePresence>
      <FramerBox
        key={"world-map"}
        initial={{ opacity: 0, x: 0, y: 400 }}
        whileInView={{
          opacity: 1,
          x: 0,
          y: 0,
        }}
        exit={{ opacity: 0, x: 0, y: 0, scale: 0 }}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        transition={{
          duration: 0.2,
          ease: "easeInOut",
        }}
        display={{ base: "none", md: "block" }}
      >
        <Box
          maxW={"full"}
          position={"relative"}
          py={{ base: 8, md: 20 }}
        >
          <Icon
            as={SvgWorldMap}
            color={"gray.300"}
            w={"full"}
            h={"full"}
          />

          {Countries.map((country, index) => (
            <FramerBox
              key={index}
              initial={{ opacity: 0, x: 0, y: 0 }}
              whileInView={{
                opacity: 1,
                x: 0,
                y: 0,
              }}
              exit={{ opacity: 0, x: 0, y: 0, scale: 0 }}
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              transition={{
                duration: 0.2,
                ease: "easeInOut",
                delay: (index + 1) * 0.1,
              }}
              display={{ base: "none", md: "block" }}
            >
              <Icon
                key={index}
                as={country.svg}
                color={"brand.primary"}
                aria-label={country.title}
                w={"full"}
                h={"full"}
                left={0}
                right={0}
                top={0}
                bottom={0}
                position={"absolute"}
              />
            </FramerBox>
          ))}
        </Box>
      </FramerBox>
    </AnimatePresence>
  )
}

export default FooterWorldMap
